import React, { useEffect, useState } from "react";
import {
  BiHeart,
  BiMessage,
  BiSend,
  BiShare,
  BiShareAlt,
} from "react-icons/bi";
import { BsFillHeartFill, BsHeartFill } from "react-icons/bs";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";
import { actionType } from "../Context/reducer";
import { useStateValue } from "../Context/StateProvider";
import SearchBar from "./SearchBar";

function Comments({ likes, shares, messages }) {
  const [liked, setLiked] = useState(false);
  //   const [share, setShare] = useState(false);
  const [nav, setNav] = useState(true);
  const handleNav = () => {
    setNav(!nav);
  };

  const [message, setMessage] = useState(true);
  const handleMessage = () => {
    setMessage(!message);
  };

  //
  const [{ allSongs, song }, dispatch] = useStateValue();

  useEffect(() => {
    if (song > allSongs.length) {
      dispatch({
        type: actionType.SET_SONG,
        song: 0,
      });
    }
  }, [song]);
  //
  return (
    <div className="flex justify-center items-center z-50 bg-white border-2 border-blue-500 p-1 rounded-md">
      <div className="flex justify-center items-center gap-4">
        {liked ? (
          <BsFillHeartFill
            fontSize="medium"
            className="text-red-600"
            onClick={(e) => setLiked(false)}
          />
        ) : (
          <BiHeart
            fontSize="medium"
            className="text-red-600"
            onClick={(e) => setLiked(true)}
          />
        )}
        <p>{liked ? 1 : 0}</p>
        {/* <div className="videoSidebar__button">
          <BiMessage
            fontSize="medium"
            className="text-blue-600"
            onClick={handleMessage}
          />
          {!message ? (
            <div className="absolute z-50 text-center right-[1%] rounded-md w-[100%] bg-gradient-to-r from-gray-400 via-gray-100 to-white p-2">
              <textarea
                placeholder="Comment"
                className="w-[100%] border-2 border-x-red-600 border-y-blue-600 rounded-md outline-none bg-gradient-to-tr from-blue-300 via-red-200 to to-blue-100 font-serif text-blue-700"
              />
              <BiSend className="text-blue-700 text-2xl absolute top-[25%] right-[5%] hover:ease-out" />
              <p className=" text-left bg-white p-1 rounded-md border-blue-400 border-2">
                {allSongs[song]?.comments}
              </p>
            </div>
          ) : (
            <div className="hidden"></div>
          )}
          <p>{messages}</p>
        </div> */}
        <div className="videoSidebar__button">
          <BiShareAlt
            fontSize="medium"
            className="text-blue-600"
            onClick={handleNav}
            // onClick={() => setShare(true)}
          />
          {/* <p>{shares}</p> */}
        </div>
      </div>

      {!nav ? (
        <div
          className={
            "absolute bg bg-gray-300 flex gap-4 z-50 rounded-md bottom-[-10%] p-2 ease-in-out duration-500"
          }
        >
          <FacebookShareButton
            url="https://asuclients.vercel.app/"
            quote="Asu"
            hashtag="#muo"
          >
            <FacebookIcon size={40} className="rounded-full" />
          </FacebookShareButton>

          <TwitterShareButton
            url="https://asuclients.vercel.app/"
            quote="Asu"
            hashtag="#muo"
          >
            <TwitterIcon size={40} className="rounded-full" />
          </TwitterShareButton>
        </div>
      ) : (
        <div className="hidden"></div>
      )}
    </div>
  );
}

export default Comments;
